import { type ComponentType, Suspense } from 'react';
import { genericMemo } from '@direct-frontend/stdlib';
import { YandexMapsApiProvider, YMapAddon } from '@adv-frontend/yandex-maps-kit';
import { getRequestContext } from '../requestContext';

const addons = [YMapAddon.clusterer, YMapAddon.defaultUITheme];

export function withYandexMapsApiProvider<TProps extends object>(
    BaseComponent: ComponentType<TProps>
): ComponentType<TProps> {
    return genericMemo(function WithYandexMapsApiProvider(props: TProps) {
        const { nonce, yandexMapGeoCoderAPIKey, yandexMapRouteAPIKey } = getRequestContext();
        const apiKeysConfig = {
            router: yandexMapRouteAPIKey,
        };

        if (!yandexMapGeoCoderAPIKey) {
            return null;
        }

        return (
            <YandexMapsApiProvider
                mapsApiKey={yandexMapGeoCoderAPIKey}
                cspNonce={nonce}
                addons={addons}
                apiKeysConfig={apiKeysConfig}
                queryParams={{
                    csp: '202512',
                }}
            >
                <Suspense>
                    <BaseComponent {...props} />
                </Suspense>
            </YandexMapsApiProvider>
        );
    });
}
